import { Attributes } from '@leverege/ui-attributes';
function getScanAttrs(context) {
  const {
    clientProps: {
      filterModel,
      objectType
    } = {}
  } = context;
  let attrs;
  if (filterModel?.fields) {
    // use fields
    attrs = filterModel.fields.map(field => {
      return Attributes.getAttribute(field?.attrName, objectType);
    });
  } else {
    // go by objectType
    attrs = Attributes.getAttributesFor(objectType);
  }
  return attrs.filter(attr => {
    return attr?.source?.attribute?.getTagStartingWith?.('scannable:', true) && !attr?.source?.forwarded && !attr?.source?.meta;
  });
}
function getScannableType(context) {
  const scanAttrs = getScanAttrs(context);
  return scanAttrs[0]?.source?.attribute?.hasTag('scannable:qr') ? 'qr' : 'barcode';
}
export default {
  getScanAttrs,
  getScannableType
};